import HelloWorld from './HelloWorld.vue';
import Loader from './Loader.vue';
import SvgStadium from './SvgStadium.vue';
import SvgZoomer from './SvgZoomer.vue';
import SvgSeats from './SvgSeats.vue';
import SvgBlocks from './SvgBlocks.vue';
import SvgModal from './SvgModal.vue';
import CounterInput from './CounterInput.vue';
import Voucher from './Voucher.vue';
import Countdown from './Countdown.vue';

import CardShadow from './CardShadow.vue';
import CardVs from './CardVs.vue';
import CardLogoVs from './CardLogoVs.vue';

import QuantityForm from './QuantityForm.vue';
import FormBuyer from './FormBuyer.vue';
import DetailSidebarExtra from './DetailSidebarExtra.vue';

import UserDataBuyEvents from './UserDataBuyEvents.vue';
import FormPayCard from './FormPayCard.vue';

import Ticket from './Ticket.vue';
import TicketList from './TicketList.vue';
import TicketPrint from './TicketPrint.vue';
import TicketFutbol from './TicketFutbol.vue';
import TicketText from './TicketText.vue';
import Repayment from './Repayment.vue';
import Panorama from './Panorama.vue';

const components = {
  HelloWorld,
  Loader,
  SvgStadium,
  SvgZoomer,
  SvgSeats,
  SvgBlocks,
  SvgModal,
  CounterInput,
  Voucher,
  Countdown,
  CardShadow,
  QuantityForm,
  FormBuyer,
  DetailSidebarExtra,
  UserDataBuyEvents,
  CardVs,
  CardLogoVs,
  FormPayCard,
  Ticket,
  TicketList,
  TicketPrint,
  TicketFutbol,
  TicketText,
  Repayment,
  Panorama,
};

components.install = (Vue) => {
  // Register components
  Object.keys(components).forEach((componentName) => {
    const component = components[componentName];
    if (component && componentName !== 'install') {
      Vue.component(componentName, component);
    }
  });
};

export default components;
